const divFromEquipService = {
  noServices: 'No added service',
  noFound: 'No services found',
  onDemand: 'Service on demand',
  remaining: (date, days) => days === 1 ? `Expiration date: ${date} (${days} day remaining)` : `Expiration date: ${date} (${days} days remaining)`,
  inDelay: (date, days) => days === 1 ? `Expiration date: ${date} (${days} day in delay)` : `Expiration date: ${date} (${days} days in delay)`,
  lastDay: 'Service will expire soon, last day of validity',
  mandatory: 'Mandatory',
  haveOpenedActions: (actions) => actions === 1 ? `(Service has ${actions} opened or overdue action)` : `(Service has ${actions} opened or overdue actions)`,
  scheduledTo: 'Scheduled to:',
  scheduledDate: 'Scheduled date:',
  inactive: 'INACTIVE',
  loadMore: 'Show more',
};

export default divFromEquipService;
